import actionDispatcher from 'api/actionDispatcher';
import {
    documentStatusApi,
    documentSessionApi,
    documentInitiateApi,
    getGraphStatisticsApi,
    initiateUserPdfReportApi,
} from 'api/apiCall';

import actionType from 'redux/actions/actionConstant';

export const apiTimeAction = (value) => ({
    type: actionType.API_CALL_TIME_CHANGED,
    payload: value,
});

export const notifiedLowBalanceAction = () => ({
    type: actionType.NOTIFIED_LOW_BALANCE,
});

// Re-arm the low-balance banner after a top-up so it can warn again next time
// the balance runs low (the flag is set when the user dismisses the banner).
export const resetNotifiedLowBalanceAction = () => ({
    type: actionType.RESET_NOTIFIED_LOW_BALANCE,
});

export const signDocumentStatusAction = (commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: documentStatusApi.bind(null, token),
        actionTypeSuccess: actionType.SIGN_DOCUMENT_STATUS_SUCCESS,
        actionTypeFailure: actionType.SIGN_DOCUMENT_STATUS_FAILURE,
        actionTypeInProgress: actionType.SIGN_DOCUMENT_STATUS_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const signDocumentSessionAction = (commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: documentSessionApi.bind(null, token),
        actionTypeSuccess: actionType.SIGN_DOCUMENT_SESSION_SUCCESS,
        actionTypeFailure: actionType.SIGN_DOCUMENT_SESSION_FAILURE,
        actionTypeInProgress: actionType.SIGN_DOCUMENT_SESSION_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const signDocumentInitiateAction = (commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: documentInitiateApi.bind(null, token),
        actionTypeSuccess: actionType.SIGN_DOCUMENT_INITIATE_SUCCESS,
        actionTypeFailure: actionType.SIGN_DOCUMENT_INITIATE_FAILURE,
        actionTypeInProgress: actionType.SIGN_DOCUMENT_INITIATE_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const documentSignedDateAction = (date) => ({
    type: actionType.DOCUMENT_SIGNED_DATE,
    payload: date,
});

export const clearDocumentSignedDateAction = () => ({
    type: actionType.CLEAR_DOCUMENT_SIGNED_DATE,
});

export const getGraphStatisticsAction = (
    filter_type,
    commonConfig,
    token,
    start_date,
    end_date,
    cb = () => {}
) => {
    return actionDispatcher({
        serviceMethod: getGraphStatisticsApi.bind(null, filter_type, token, start_date, end_date),
        actionTypeSuccess: actionType.GET_GRAPH_STATISTICS_SUCCESS,
        actionTypeFailure: actionType.GET_GRAPH_STATISTICS_FAILURE,
        actionTypeInProgress: actionType.GET_GRAPH_STATISTICS_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });
};

export const initiateUserPdfReportAction = (data, commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: initiateUserPdfReportApi.bind(null, data, token),
        actionTypeSuccess: actionType.INITIATE_USER_PDF_REPORT_SUCCESS,
        actionTypeFailure: actionType.INITIATE_USER_PDF_REPORT_FAILURE,
        actionTypeInProgress: actionType.INITIATE_USER_PDF_REPORT_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const updateGeneratedPdfReportAction = (reportDetails, userAccessCode, previousReports) => {
    const generatedUserPdfReports = { ...previousReports };

    generatedUserPdfReports[userAccessCode] = reportDetails;

    return {
        type: actionType.UPDATE_GENERATED_PDF_REPORTS,
        payload: generatedUserPdfReports,
    };
};

export const removeReportFromGeneratedUserPdfReportAction = (userAccessCode, previousReports) => {
    const generatedUserPdfReports = { ...previousReports };

    delete generatedUserPdfReports?.[userAccessCode];

    return {
        type: actionType.UPDATE_GENERATED_PDF_REPORTS,
        payload: generatedUserPdfReports,
    };
};

export const updateSetupGuideStatusAction = (setupGuideStatus) => {
    return {
        type: actionType.UPDATE_SETUP_GUIDE_STATUS,
        payload: setupGuideStatus,
    };
};

export const markSetupGuideAsCompleteAction = () => {
    return {
        type: actionType.MARK_SETUP_GUIDE_AS_COMPLETE,
    };
};

export const updateEnvironmentWarningAction = (show) => {
    return {
        type: actionType.SHOW_ENVIRONMENT_WARNING,
        payload: show,
    };
};
